import { UserType } from '../../constants/user.constants';
import useUserContext from '../../components/contexts/UserData/UserData';
import useWorkspaceContext from '../../components/workspaces/WorkspaceContext/WorkspaceContext';

const useWorkspacePermissions = () => {
  const { userData, isAdmin } = useUserContext();
  const { workspaceUsers } = useWorkspaceContext();

  const currentUserId = userData?.id;
  const rawRole = workspaceUsers?.find(u => u.userId === currentUserId)?.userType;
  const currentUserRole = rawRole?.toLowerCase();

  const isViewer = currentUserRole === UserType.VIEWER;
  const canModify = isAdmin || currentUserRole === UserType.OWNER || currentUserRole === UserType.EDITOR;

  return {
    isViewer,
    canModify,
  };
};

export default useWorkspacePermissions;
